import { setTitle } from '../../utils/util'
export default (router) => {
    router.beforeEach((to, from, next) => {
        let meta = to.meta
        if (meta && meta.title) {
            setTitle(meta.title)
        }
        next()
    })
}
